/**
 * Shortcut Configuration Data
 * Defines available pages, tables, and actions for keyboard shortcut configuration
 */

const SHORTCUT_PAGES = [
  {
    id: 'trading-view',
    label: 'Trading View',
    route: '/trading-view',
    tables: [
      {
        id: 'quick-order-entry',
        label: 'Quick Order Entry',
        actions: [
          { id: 'buy_ce', label: 'Buy CE', type: 'button' },
          { id: 'sell_ce', label: 'Sell CE', type: 'button' },
          { id: 'buy_pe', label: 'Buy PE', type: 'button' },
          { id: 'sell_pe', label: 'Sell PE', type: 'button' },
          { id: 'order_type_limit', label: 'LMT (Limit Order)', type: 'toggle' },
          { id: 'order_type_market', label: 'MKT (Market Order)', type: 'toggle' },
          { id: 'product_type_nrml', label: 'NRML (Normal)', type: 'toggle' },
          { id: 'product_type_mis', label: 'MIS (Intraday)', type: 'toggle' },
          { id: 'ce_qty_increase', label: 'CE Qty Increase', type: 'button' },
          { id: 'ce_qty_decrease', label: 'CE Qty Decrease', type: 'button' },
          { id: 'pe_qty_increase', label: 'PE Qty Increase', type: 'button' },
          { id: 'pe_qty_decrease', label: 'PE Qty Decrease', type: 'button' },
          { id: 're_enter_ce', label: 'Re-Enter CE', type: 'button' },
          { id: 're_enter_pe', label: 'Re-Enter PE', type: 'button' },
        ]
      },
      {
        id: 'ce-options-table',
        label: 'CE Options Table',
        actions: [
          { id: 'ce_table_buy', label: 'Buy Selected CE', type: 'button' },
          { id: 'ce_table_sell', label: 'Sell Selected CE', type: 'button' },
          { id: 'ce_table_flip', label: 'Flip CE Table', type: 'toggle' },
          { id: 'ce_strike_up', label: 'CE Strike Up', type: 'button' },
          { id: 'ce_strike_down', label: 'CE Strike Down', type: 'button' },
        ]
      },
      {
        id: 'pe-options-table',
        label: 'PE Options Table',
        actions: [
          { id: 'pe_table_buy', label: 'Buy Selected PE', type: 'button' },
          { id: 'pe_table_sell', label: 'Sell Selected PE', type: 'button' },
          { id: 'pe_table_flip', label: 'Flip PE Table', type: 'toggle' },
          { id: 'pe_strike_up', label: 'PE Strike Up', type: 'button' },
          { id: 'pe_strike_down', label: 'PE Strike Down', type: 'button' },
        ]
      },
      {
        id: 'positions-table',
        label: 'Positions / Trade Book / Order Book',
        actions: [
          { id: 'view_positions', label: 'View Positions', type: 'toggle' },
          { id: 'view_trades', label: 'View Trade Book', type: 'toggle' },
          { id: 'view_orderbook', label: 'View Order Book', type: 'toggle' },
          { id: 'exit_selected_position', label: 'Exit Selected Position', type: 'button' },
          { id: 'flip_main_table', label: 'Flip Main Table', type: 'toggle' },
        ]
      },
      {
        id: 'exchange-tabs',
        label: 'Exchange Tabs',
        actions: [
          { id: 'tab_nse', label: 'Switch to NSE', type: 'toggle' },
          { id: 'tab_nfo', label: 'Switch to NFO', type: 'toggle' },
          { id: 'tab_bse', label: 'Switch to BSE', type: 'toggle' },
          { id: 'tab_bfo', label: 'Switch to BFO', type: 'toggle' },
          { id: 'tab_mcx', label: 'Switch to MCX', type: 'toggle' },
        ]
      },
    ]
  },
  {
    id: 'nse-options-trade',
    label: 'NSE Options Trade',
    route: '/nse-options-trade',
    tables: [
      {
        id: 'option-chain-grid',
        label: 'Option Chain Grid',
        actions: [
          { id: 'buy_ce', label: 'Buy CE (Active Frame)', type: 'button' },
          { id: 'sell_ce', label: 'Sell CE (Active Frame)', type: 'button' },
          { id: 'buy_pe', label: 'Buy PE (Active Frame)', type: 'button' },
          { id: 'sell_pe', label: 'Sell PE (Active Frame)', type: 'button' },
        ]
      },
      {
        id: 'positions-table',
        label: 'Positions / Trade Book / Order Book',
        actions: [
          { id: 'view_positions', label: 'View Positions', type: 'toggle' },
          { id: 'view_trades', label: 'View Trade Book', type: 'toggle' },
          { id: 'view_orderbook', label: 'View Order Book', type: 'toggle' },
          { id: 'exit_selected_position', label: 'Exit Selected Position', type: 'button' },
          { id: 'flip_grid', label: 'Flip Grid (Options / Positions)', type: 'toggle' },
        ]
      },
      {
        id: 'grid-controls',
        label: 'Grid Controls',
        actions: [
          { id: 'grid_rows_increase', label: 'Increase Grid Rows', type: 'button' },
          { id: 'grid_rows_decrease', label: 'Decrease Grid Rows', type: 'button' },
          { id: 'toggle_nifty_panel', label: 'Toggle Nifty Panel', type: 'toggle' },
        ]
      },
    ]
  },
  {
    id: 'option-chain',
    label: 'Option Chain',
    route: '/option-chain',
    tables: [
      {
        id: 'option-chain-table',
        label: 'Option Chain Table',
        actions: [
          { id: 'buy_ce', label: 'Buy CE (Selected Strike)', type: 'button' },
          { id: 'sell_ce', label: 'Sell CE (Selected Strike)', type: 'button' },
          { id: 'buy_pe', label: 'Buy PE (Selected Strike)', type: 'button' },
          { id: 'sell_pe', label: 'Sell PE (Selected Strike)', type: 'button' },
          { id: 'strike_up', label: 'Move Strike Up', type: 'button' },
          { id: 'strike_down', label: 'Move Strike Down', type: 'button' },
        ]
      },
    ]
  },
];

// All available modifier keys
const MODIFIER_KEYS = ['Ctrl', 'Shift', 'Alt', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12'];

// Full QWERTY keyboard layout for the visual keyboard
const KEYBOARD_LAYOUT = [
  // Row 1: Escape + F-keys
  [
    { key: 'Escape', label: 'Esc', width: 1 },
    { key: 'F1', label: 'F1', width: 1 },
    { key: 'F2', label: 'F2', width: 1 },
    { key: 'F3', label: 'F3', width: 1 },
    { key: 'F4', label: 'F4', width: 1 },
    { key: 'F5', label: 'F5', width: 1 },
    { key: 'F6', label: 'F6', width: 1 },
    { key: 'F7', label: 'F7', width: 1 },
    { key: 'F8', label: 'F8', width: 1 },
    { key: 'F9', label: 'F9', width: 1 },
    { key: 'F10', label: 'F10', width: 1 },
    { key: 'F11', label: 'F11', width: 1 },
    { key: 'F12', label: 'F12', width: 1 },
  ],
  // Row 2: Numbers
  [
    { key: 'Backquote', label: '`', width: 1 },
    { key: '1', label: '1', width: 1 },
    { key: '2', label: '2', width: 1 },
    { key: '3', label: '3', width: 1 },
    { key: '4', label: '4', width: 1 },
    { key: '5', label: '5', width: 1 },
    { key: '6', label: '6', width: 1 },
    { key: '7', label: '7', width: 1 },
    { key: '8', label: '8', width: 1 },
    { key: '9', label: '9', width: 1 },
    { key: '0', label: '0', width: 1 },
    { key: 'Minus', label: '-', width: 1 },
    { key: 'Equal', label: '=', width: 1 },
    { key: 'Backspace', label: '⌫', width: 1.5 },
  ],
  // Row 3: QWERTY
  [
    { key: 'Tab', label: 'Tab', width: 1.3 },
    { key: 'Q', label: 'Q', width: 1 },
    { key: 'W', label: 'W', width: 1 },
    { key: 'E', label: 'E', width: 1 },
    { key: 'R', label: 'R', width: 1 },
    { key: 'T', label: 'T', width: 1 },
    { key: 'Y', label: 'Y', width: 1 },
    { key: 'U', label: 'U', width: 1 },
    { key: 'I', label: 'I', width: 1 },
    { key: 'O', label: 'O', width: 1 },
    { key: 'P', label: 'P', width: 1 },
    { key: 'BracketLeft', label: '[', width: 1 },
    { key: 'BracketRight', label: ']', width: 1 },
    { key: 'Backslash', label: '\\', width: 1.2 },
  ],
  // Row 4: ASDF
  [
    { key: 'CapsLock', label: 'Caps', width: 1.5 },
    { key: 'A', label: 'A', width: 1 },
    { key: 'S', label: 'S', width: 1 },
    { key: 'D', label: 'D', width: 1 },
    { key: 'F', label: 'F', width: 1 },
    { key: 'G', label: 'G', width: 1 },
    { key: 'H', label: 'H', width: 1 },
    { key: 'J', label: 'J', width: 1 },
    { key: 'K', label: 'K', width: 1 },
    { key: 'L', label: 'L', width: 1 },
    { key: 'Semicolon', label: ';', width: 1 },
    { key: 'Quote', label: "'", width: 1 },
    { key: 'Enter', label: 'Enter', width: 1.8 },
  ],
  // Row 5: ZXCV
  [
    { key: 'Shift', label: 'Shift', width: 2 },
    { key: 'Z', label: 'Z', width: 1 },
    { key: 'X', label: 'X', width: 1 },
    { key: 'C', label: 'C', width: 1 },
    { key: 'V', label: 'V', width: 1 },
    { key: 'B', label: 'B', width: 1 },
    { key: 'N', label: 'N', width: 1 },
    { key: 'M', label: 'M', width: 1 },
    { key: 'Comma', label: ',', width: 1 },
    { key: 'Period', label: '.', width: 1 },
    { key: 'Slash', label: '/', width: 1 },
    { key: 'ShiftRight', label: 'Shift', width: 2 },
  ],
  // Row 6: Bottom row
  [
    { key: 'Ctrl', label: 'Ctrl', width: 1.3 },
    { key: 'Alt', label: 'Alt', width: 1.3 },
    { key: 'Space', label: 'Space', width: 5 },
    { key: 'AltRight', label: 'Alt', width: 1.3 },
    { key: 'CtrlRight', label: 'Ctrl', width: 1.3 },
  ],
  // Row 7: Arrow keys + Navigation
  [
    { key: 'ArrowLeft', label: '←', width: 1 },
    { key: 'ArrowUp', label: '↑', width: 1 },
    { key: 'ArrowDown', label: '↓', width: 1 },
    { key: 'ArrowRight', label: '→', width: 1 },
    { key: 'Insert', label: 'Ins', width: 1 },
    { key: 'Delete', label: 'Del', width: 1 },
    { key: 'Home', label: 'Home', width: 1 },
    { key: 'End', label: 'End', width: 1 },
    { key: 'PageUp', label: 'PgUp', width: 1 },
    { key: 'PageDown', label: 'PgDn', width: 1 },
  ],
  // Row 8: Numpad (4 rows rendered side by side in the picker)
  [
    { key: 'NumLock', label: 'Num', width: 1 },
    { key: 'NumpadDivide', label: '/', width: 1 },
    { key: 'NumpadMultiply', label: '*', width: 1 },
    { key: 'NumpadSubtract', label: '−', width: 1 },
    { key: 'Numpad7', label: '7', width: 1 },
    { key: 'Numpad8', label: '8', width: 1 },
    { key: 'Numpad9', label: '9', width: 1 },
    { key: 'NumpadAdd', label: '+', width: 1 },
    { key: 'Numpad4', label: '4', width: 1 },
    { key: 'Numpad5', label: '5', width: 1 },
    { key: 'Numpad6', label: '6', width: 1 },
    { key: 'Numpad1', label: '1', width: 1 },
    { key: 'Numpad2', label: '2', width: 1 },
    { key: 'Numpad3', label: '3', width: 1 },
    { key: 'NumpadEnter', label: 'Ent', width: 1 },
    { key: 'Numpad0', label: '0', width: 2 },
    { key: 'NumpadDecimal', label: '.', width: 1 },
  ],
];

// Keys that should be highlighted in modifier selection mode
const MODIFIER_HIGHLIGHT_KEYS = ['Ctrl', 'CtrlRight', 'Shift', 'ShiftRight', 'Alt', 'AltRight', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12'];

// Keys that should NOT be available as shortcut keys (system reserved)
const RESERVED_KEYS = ['CapsLock', 'Tab', 'Backspace', 'Enter', 'Space', 'NumLock'];

// Normalize a keyboard event key to our key format
const normalizeKey = (event) => {
  const key = event.key;
  const code = event.code || '';

  // Numpad keys: use event.code to distinguish from main keyboard
  if (code.startsWith('Numpad')) {
    return code; // e.g. Numpad7, NumpadAdd, NumpadEnter, NumpadDecimal, etc.
  }
  if (code === 'NumLock') return 'NumLock';

  if (key === 'Control') return 'Ctrl';
  if (key === ' ') return 'Space';

  // Map event.code for symbol keys so we get consistent names
  const codeMap = {
    'Backquote': 'Backquote', 'Minus': 'Minus', 'Equal': 'Equal',
    'BracketLeft': 'BracketLeft', 'BracketRight': 'BracketRight',
    'Backslash': 'Backslash', 'Semicolon': 'Semicolon', 'Quote': 'Quote',
    'Comma': 'Comma', 'Period': 'Period', 'Slash': 'Slash',
  };
  if (codeMap[code]) return codeMap[code];

  if (key.length === 1) return key.toUpperCase();
  return key;
};

// Convert our stored key to display format
const keyToDisplay = (key) => {
  const map = {
    'ArrowUp': '↑', 'ArrowDown': '↓', 'ArrowLeft': '←', 'ArrowRight': '→',
    'Escape': 'Esc', 'Backspace': '⌫', 'Delete': 'Del',
    'Insert': 'Ins', 'PageUp': 'PgUp', 'PageDown': 'PgDn',
    'Backquote': '`', 'Minus': '-', 'Equal': '=',
    'BracketLeft': '[', 'BracketRight': ']', 'Backslash': '\\',
    'Semicolon': ';', 'Quote': "'", 'Comma': ',', 'Period': '.', 'Slash': '/',
    'NumLock': 'NumLock', 'NumpadDivide': 'Num /', 'NumpadMultiply': 'Num *',
    'NumpadSubtract': 'Num −', 'NumpadAdd': 'Num +', 'NumpadEnter': 'Num Enter',
    'NumpadDecimal': 'Num .', 'Numpad0': 'Num 0', 'Numpad1': 'Num 1',
    'Numpad2': 'Num 2', 'Numpad3': 'Num 3', 'Numpad4': 'Num 4',
    'Numpad5': 'Num 5', 'Numpad6': 'Num 6', 'Numpad7': 'Num 7',
    'Numpad8': 'Num 8', 'Numpad9': 'Num 9',
  };
  return map[key] || key;
};

export { SHORTCUT_PAGES, MODIFIER_KEYS, KEYBOARD_LAYOUT, MODIFIER_HIGHLIGHT_KEYS, RESERVED_KEYS, normalizeKey, keyToDisplay };
